/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/ssms' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/MutationLink.js